import { colors, makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  tableHeader: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.grey[400],
  },
  empty: {
    color: '#666',
  },
}))

export default styles
